import React from 'react'
import gql from 'graphql-tag'
import DeliveredUrl from 'components/shared/DeliveredUrl'
import ProductInputAssets from 'components/shared/ProductInputAssets'
import DefaultProductStatus from '../../DefaultProductStatus'

const EnergyLabelingProduct = ({product}) => {
  if (product.canProvideUserInput) {
    return (
      <ProductInputAssets
        product={product}
        description={
          <>
            <p>Last opp takstpapirer på boligen så vi kan produsere Energimerking.</p>
            <p>Energimerking leveres innen 2 arbeidsdager.</p>
          </>
        }
      />
    )
  }

  if (product.state === 'delivered') {
    return (
      <DeliveredUrl product={product} />
    )
  }

  return (
    <DefaultProductStatus product={product} />
  )
}

EnergyLabelingProduct.fragment = gql`
  fragment EnergyLabelingProduct on Product {
    ...on EnergyLabelingProduct {
      assets {
        edges {
          node {
            id
            ...on DocumentAsset {
              url
              scope
            }
          }
        }
      }
    }
  }
`

export default EnergyLabelingProduct
